import Tabs from "../../../../components/tabs/Tabs";
import { useEffect, useState } from "react";
import ToDoChecklist from "./ToDoChecklist/ToDoChecklist";
import RemainingChecklist from "./RemainingChecklist/RemainingChecklist";
import AllChecklist from "./AllChecklist/AllChecklist";
import { BoxTabs } from "../../../../components/AntdTab/AntdTab";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckListMiddleware } from "../../../../Store/Middlewares/CheckListMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "antd";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";

const Checklist = () => {
  const [Rloading, setRloading] = useState(true);
  const [Aloading, setAloading] = useState(true);

  // const ChecklistAll = useSelector((state) => state.EventReducer.All_CheckList);

  const role = Storage.getERole("@role");

  const dispatch = useDispatch();
  const { state } = useLocation();
  console.log("state", state?.id);

  // useEffect(() => {
  //   getChecklist();
  // }, []);

  // console.log("Monthly",Monthly);

  const items = [
    {
      key: "1",
      label: "This Week",
      children: (
        <ToDoChecklist addTaskBtn={true} status="weekly" />
      ),
    },
    {
      key: "2",
      label: "This Month",
      children: (
        // <Skeleton loading={Rloading}>
        <ToDoChecklist showDueDate status="monthly" />
        // </Skeleton>
      ),
    },
    {
      key: "3",
      label: "All",
      children: (
        // <Skeleton loading={Aloading}>
        <AllChecklist addTaskBtn={true} />
        // </Skeleton>
      ),
    },
  ];

  return (
    // <Tabs
    //   tabLinks={tabLinks}
    //   selectedTab={selectedTab}
    //   setSelectedTab={setSelectedTab}
    // />
    <BoxTabs items={items} destroyOnBlur />
  );
};

export default Checklist;
